'use client';

import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectAction,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectValue,
} from 'keep-react';
import { getCountryOptions } from '@/lib/constants/countries';

interface CountrySelectProps {
  name: string;
  control: Control<any>;
  label?: React.ReactNode;
  placeholder?: string;
  className?: string;
  defaultValue?: string;
  required?: boolean;
  error?: string;
}

export const CountrySelect = ({
  name,
  control,
  label,
  placeholder,
  className = '',
  required = false,
  error
}: CountrySelectProps) => {
  const { i18n } = useTranslation();
  const locale = i18n.language === 'en' ? 'en' : 'de';
  const countryOptions = getCountryOptions(locale);

  return (
    <div className={`space-y-2 ${className}`}>
      {label && (
        <label className="text-[var(--color-slate-600)] font-inter font-medium leading-5 tracking-tight">
          {label}
          {required && <span className="text-red-500 ml-0.5">*</span>}
        </label>
      )}
      
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Select
            onValueChange={(value) => {
              field.onChange(value);
              field.onBlur();
            }}
            value={field.value as string}
          >
            <SelectAction>
              <SelectValue
                placeholder={placeholder}
                className={error ? "text-red-500" : ""}
              />
            </SelectAction>
            <SelectContent className="max-h-60 overflow-y-auto">
              <SelectGroup>
                {countryOptions.map((country) => (
                  <SelectItem key={country.value} value={country.value}>
                    {country.label}
                  </SelectItem>
                ))}
              </SelectGroup>
            </SelectContent>
          </Select>
        )}
      />
      
      {error && (
        <p className="text-red-500 text-sm">{error}</p>
      )}
    </div>
  );
};